module.exports = {"id":"213620","name":"Felipe Mora","rating":"75","photo":"./data/images/photos/4/213620.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FelipeMora0.json
// module id = 1402
// module chunks = 0